import { Component, Output, EventEmitter, Input } from '@angular/core';
import { ToasterService } from '#services/shared';

@Component({
    selector: 'app-drag-drop',
    templateUrl: './drag-drop.component.html',
    styleUrls: ['./drag-drop.component.scss'],
  standalone: false
})

export class DragDropComponent {
    @Input() format: string;
    @Output() fileListChanged = new EventEmitter<File>();
    file: File;

    constructor(private toaster: ToasterService) {
    }

    uploadFile(event) {
        // take only first valid file
        let hasInvalidExtensions = false;
        const allowedFormats = this.getAllowedFormats();

        for (let index = 0; index < event.length; index++) {
            const element = event[index];
            const extension = this.getExtension(element.name).toLowerCase();

            if (allowedFormats.indexOf(extension) === -1) {
                hasInvalidExtensions = true;
                continue;
            }

            this.file = element;
            break;
        }

        if (hasInvalidExtensions) {
            const formatsLabel = allowedFormats.join(', ');
            const suffix = allowedFormats.length > 1 ? 'extensions are' : 'extension is';
            this.toaster.showWarn('Wrong file format', `Only ${formatsLabel} ${suffix} allowed.`);
        }

        this.fileListChanged.emit(this.file);
    }

    getAllowedFormats(): string[] {
        return (this.format || '')
            .split(',')
            .map(f => f.trim().toLowerCase())
            .filter(f => f.length > 0);
    }

    getExtension(filename: string) {
        return '.' + filename.split('.').pop();
    }
}
